export default {
  labels: {
    today: 'I dag',
    pickup_time: 'Afhentningstid',
    delivery_time: 'Leveringstid',
  },
};
